<template>
    <div class="project-app-wrapper">
    <div class="left" :class="getClass()" v-show="!['/wayline-edit-planar','/wayline-edit'].indexOf(root.$route.path) > -1">
      <Sidebar />
      <div class="main-content uranus-scrollbar dark">
        <router-view />
      </div>
      <div class="menu-icon" @click="handleChangeCollapsed" v-if="showHeader" v-show="!['/wayline-edit-planar','/wayline-edit'].indexOf(root.$route.path) > -1">
        <CaretLeftOutlined  v-if="collapsed"/>
        <CaretRightOutlined v-else/>
      </div>
    </div>
    <slot></slot>
</div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import Sidebar from '/@/components/common/sidebar.vue'
import { useMyStore } from '/@/store'
import { getRoot } from '/@/root'

const root = getRoot()
const store = useMyStore()
const collapsed = computed(() => store.state.collapsed)

const showHeader = computed(() => {
  return store.state.headerVisible
})
function getClass () {
  let cls = ''
  if (['/wayline-edit-planar', '/wayline-edit', '/wayline-edit-strip'].indexOf(root.$route.path) > -1) {
    cls += 'custom'
  }
  if (!collapsed.value) cls += ' no-sidebar'
  return cls
}

function handleChangeCollapsed () {
  store.commit('SET_COLLAPSED', !collapsed.value)
}

</script>
<style lang="scss" scoped>
    .project-app-wrapper {
  display: flex;
  transition: width 0.2s ease;
  height: 100vh;
  width: 100%;

  .left {
    position: relative;
    transition: width 0.2s ease-in-out;
    display: flex;
    width: 0px;
    flex: 0 0 82px;
    background-color: #232323;

    .main-content {
      flex: 1;
      color: $text-white-basic;
      width: 0px;
    }
    .menu-icon{
    width: 30px;
    height: 30px;
    padding: 10px;
    color: #f6f8fa;
    position: fixed;
    top: 15px;
    left: 280px;
    z-index: 1000;
    cursor: pointer;
    background-color: #02274b;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  }
}
</style>
